import React, { ReactElement } from 'react';
import maintainImage from '../../../assets/png/cleve_maintenance.png';
import { ImageCustom } from '../ImageCustom';
import './MaintainPage.scss';

export const MaintainPage = (): ReactElement => {
  return (
    <div className="root-maintain">
      <div className="maintain-image">
        <ImageCustom src={maintainImage} />
      </div>
      <div className="maintain-description">
        ご利用の皆様にはご迷惑を おかけしており大変申し訳ございません。
        メンテナンス終了までしばらくお待ちください
      </div>
      <h3 style={{ fontWeight: '700' }}>メンテナンス時間</h3>
      <div>Loading ...</div>
      <a
        href="https://x.com/everylive_jp?s=11&t=4WHwDFE_dIbttYRELJPpkQ"
        target="_blank"
        rel="noopener noreferrer"
        className="maintain-button"
      >
        公式Xはこちら
      </a>
      <div className="maintain-button-description">
        ※メンテナンス完了時にアナウンス致します。
      </div>
    </div>
  );
};
